import { useEffect, useState } from 'react';

import { useContentLikes } from './useContentLikes';
import { useUserLike } from './useUserLike';

export const useLikes = ({ brandSlug, contentType, id, slug, likeType }) => {
  const { count, isReady: isContentReady } = useContentLikes({
    brandSlug,
    contentType,
    id,
    slug,
  });
  const { isLiked, isUserReady, toggleLike } = useUserLike({
    id,
    likeType,
  });
  const [likeCount, setLikeCount] = useState(count);

  useEffect(() => {
    setLikeCount(count);
  }, [count]);

  function toggle() {
    const result = toggleLike();

    if (result === null) {
      return null;
    }

    const diff = result === true ? 1 : -1;
    setLikeCount(likeCount + diff);

    return result;
  }

  return {
    isLikedByUser: isLiked,
    isReady: isContentReady && isUserReady,
    likeCount,
    toggle,
  };
};
